'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'bomb';
var width = 576;
var height = 512;
var aliases = [128163];
var unicode = 'f1e2';
var svgPathData = ['M392 64l64 24 24 64 24-64 64-24-64-24-24-64-24 64-64 24z', 'M344 74.7L446.6 177.4 469.3 200c-17 17-28.2 28.2-33.5 33.5 7.9 22 12.2 45.7 12.2 70.5 0 114.9-93.1 208-208 208S32 418.9 32 304 125.1 96 240 96c24.7 0 48.5 4.3 70.5 12.3 5.3-5.3 16.5-16.5 33.5-33.5zM144 304c0-53 43-96 96-96l24 0 0-48-24 0c-79.5 0-144 64.5-144 144l0 24 48 0 0-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBomb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;